module.exports = __webpack_public_path__ + "static/Ministry_of_Health_(Vietnam)_Logo-9d9f009c0097b02d6844382c531a4031.svg";